import Moment from 'moment';
import { extendMoment } from 'moment-range';
const moment = extendMoment(Moment);

export function getMomentDate(dateString = null) {
    if (dateString === null) {
        return moment.utc().utcOffset(-1, true);
    }
    else {
        return moment.utc(dateString).utcOffset(-1, true)
    }
}

export function jsDateFromString(dateString) {
    return moment.utc(dateString).utcOffset(1, true).toDate();
}

export function getJSONDate(momentDate) {
    return momentDate.clone().utc().utcOffset(1, true);
}

export function startOfWeekToYMD(momentDate) {
    return momentDate.clone().startOf('isoWeek').format('YYYY-MM-DD');
}

export function endOfWeekToYMD(momentDate) {
    return momentDate.clone().endOf('isoWeek').format('YYYY-MM-DD');
}

export function addDays(momentDate, number) {
    return momentDate.clone().add(number, 'days');
}

export function addMinutes(momentDate, number) {
    return momentDate.clone().add(number, 'minutes');
}

export function addHours(momentDate, number) {
    return momentDate.clone().add(number, 'hours');
}

export function getWeekDays(momentDate) {
    let weekStart = momentDate.clone().startOf('isoWeek');
    let momentDays = [];
    [0, 1, 2, 3, 4, 5, 6].forEach((index) => {
        momentDays.push(weekStart.clone().add(index, 'days'));
    });
    return momentDays;
}

export function getWeekNr(momentDate) {
    return momentDate.isoWeek();
}

export function getMonthShortName(momentDate) {
    return momentDate.format('MMM');
}

export function getHHmm(momentDate) {
    return momentDate.format('HH:mm');
}

export function getDate(momentDate) {
    return momentDate.format('D');
}

export function getDayShortName(momentDate) {
    return momentDate.format('dd');
}

export function formatSlotFromTo(slot) {
    let from = slot.start.clone();
    let to = slot.end.clone();
    return formatFromTo(from, to);
}

export function formatFromTo(fromMoment, toMoment) {
    let startDate = fromMoment.format('YYYY-MM-DD');
    return `${startDate} kl ${getHHmm(fromMoment)} till ${getHHmm(toMoment)}`;
}

export function slotsOverlap(slot1Moment, slot2Moment) {
    const slot1Range = moment.range(slot1Moment.start, slot1Moment.end);
    const slot2Range = moment.range(slot2Moment.start, slot2Moment.end);
    return slot1Range.overlaps(slot2Range);
}

export function slotArrayOverlaps(slotMomentArray, slotMoment) {
    for (var i = 0; i < slotMomentArray.length; i++) {
        if (slotsOverlap(slotMomentArray[i], slotMoment)) return true;
    }
    return false;
}

export function isSameYMD(momentDate1, momentDate2) {
    return momentDate1.isSame(momentDate2, 'day');
}

export function isSameDayIndex(dayIndex, momentDate) {
    return dayIndex.toString() === momentDate.format('e');
}

export function getStartOfDay(momentDate) {
    return momentDate.clone().startOf('day');
}

export function getEndOfDay(momentDate) {
    return momentDate.clone().endOf('day');
}

export function combineDateAndTime(dateFromMoment, timeFromMoment) {
    var returnVal = dateFromMoment.clone();
    returnVal.hours(timeFromMoment.get('hours'));
    returnVal.minutes(timeFromMoment.get('minutes'));
    returnVal.seconds(timeFromMoment.get('seconds'));
    return returnVal;
}

// bookings
// [{BookedThrough: null
// BookingId: 29
// BookingTypeRefId: 3
// CreatedAt: "2019-10-19T18:33:26.197Z"
// CreatedByInitials: "ÅD"
// EndTime: "2019-10-25T13:00:00.000Z"
// ExternalUser: null
// Location: ""
// Note: ""
// PetRefId: null
// StartTime: "2019-10-25T12:00:00.000Z"
// UserRefId: null}]

// openSlots
// [{DayIndex: 0 (monday)
// StartTime: "2019-10-25T12:00:00.000Z",
// EndTime: "2019-10-25T13:00:00.000Z"}]

// exceptions
// [{StartTime: "2019-10-25T12:00:00.000Z",
// EndTime: "2019-10-25T13:00:00.000Z"}]

// bookingCategory
// {BookingTypeId: 2
// Color: "#F2E394"
// DefaultMinutes: 30
// Name: "Vaccination"
// ShortName: "VAC"}

// returns
// [{start: date, end: date}]

export function getFreeSlots(
    momentDateToCheck, bookings, openSlots,
    exceptions, bookingCategory, settings,
    currentMomentDate = getMomentDate()) {
    //debugger;
    var freeSlots = [];

    if (currentMomentDate.isAfter(momentDateToCheck, 'day')) {
        return [];
    }

    const bookingDates = bookings.map((b) => {
        return {
            start: getMomentDate(b.StartTime),
            end: getMomentDate(b.EndTime)
        }
    });

    const todaysBookings = bookingDates.filter((b) => {
        return isSameYMD(b.start, momentDateToCheck);
    });

    const slotDates = openSlots.map((s) => {
        return {
            dayIndex: s.DayIndex,
            start: getMomentDate(s.StartTime),
            end: getMomentDate(s.EndTime)
        }
    });

    const todaysSlots = slotDates.filter((s) => {
        return isSameDayIndex(s.dayIndex, momentDateToCheck);
    }).sort(_startEndTimeComparer);

    const exceptionDates = exceptions.map((e) => {
        return {
            start: getMomentDate(e.StartTime),
            end: getMomentDate(e.EndTime)
        }
    });

    var fullDaySlot = {
        start: getStartOfDay(momentDateToCheck),
        end: getEndOfDay(momentDateToCheck)
    }
    const todaysExceptions = exceptionDates.filter((e) => {
        return slotsOverlap(fullDaySlot, e);
    });

    const categoryMinutes = bookingCategory.DefaultMinutes;
    const blockMinutes = 15;

    // loop our slots
    var minuteOffset = 0;
    todaysSlots.forEach((s) => {
        var start = combineDateAndTime(momentDateToCheck, s.start);
        var end = combineDateAndTime(momentDateToCheck, s.end);
        var slotToday = {
            start: start,
            end: end
        }
        while (true) {
            // Create the slot to check
            var slotStart = addMinutes(slotToday.start, minuteOffset);
            var slotToCheck = {
                start: slotStart,
                end: addMinutes(slotStart, categoryMinutes)
            }

            // Check that the current slot fits in the open slot
            const endsAfterCurrentOpenSlot = slotToCheck.end > slotToday.end;
            if (endsAfterCurrentOpenSlot) {
                minuteOffset = 0;
                return;
            }

            // Check if the current slot overlaps an exception interval
            const exceptionOverlap = slotArrayOverlaps(todaysExceptions, slotToCheck);
            if (exceptionOverlap) {
                minuteOffset += blockMinutes;
                continue;
            }

            // Check if the current slot overlaps another booking
            const bookingOverlap = slotArrayOverlaps(todaysBookings, slotToCheck);
            if (bookingOverlap) {
                minuteOffset += blockMinutes;
                continue;
            }

            // Check if slot has already passed or started
            if (getMomentDate(currentMomentDate) > slotToCheck.start) {
                minuteOffset += blockMinutes;
                continue;
            }

            if (settings && settings.OnlineBookingHoursInAdvance) {
                const hours = parseInt(settings.OnlineBookingHoursInAdvance);
                if (hours) {
                    if (slotToCheck.start < addHours(currentMomentDate, hours)) {
                        minuteOffset += blockMinutes;
                        continue;
                    }
                }

            }

            // Slot is ok
            freeSlots.push(slotToCheck);
            minuteOffset += categoryMinutes;
        }
    });

    return freeSlots;
}

function _startEndTimeComparer(a, b) {
    if (a.StartTime < b.EndTime) {
        return -1;
    }
    if (a.StartTime > b.EndTime) {
        return 1;
    }
    return 0;
}
